import { init } from '@rematch/core';
import { auth } from './pages/Login/models';
import { users } from './pages/Users/models';
import { permissions } from './pages/Permissions/models';
import { hotels } from './pages/Hotels/models';
import { rooms } from './pages/RoomManagement/models';
import { branding } from './models/branding';

const models = {
    auth,
    users,
    permissions,
    hotels,
    rooms,
    branding,
};

export const store = init({
    models,
});
